// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { ThirdPartyWebinar } from '../models';
import { ThirdPartyWebinarCreate } from '../models';
import { ThirdPartyWebinarEdit } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * ThirdPartyWebinarApi - axios parameter creator
 * @export
 */
export const ThirdPartyWebinarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.content_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create new third party webinar.
         * @param {ThirdPartyWebinarCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: ThirdPartyWebinarCreate, options: any = {}): RequestArgs {
            const localVarPath = `/v1/webinar/third-party`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner
         * @summary Edit third party webinar.
         * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
         * @param {ThirdPartyWebinarEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: ThirdPartyWebinarEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/webinar/third-party/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner`
         * @summary Get third party webinar.
         * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/webinar/third-party/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThirdPartyWebinarApi - functional programming interface
 * @export
 */
export const ThirdPartyWebinarApiFp = function(configuration?: Configuration) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.content_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create new third party webinar.
         * @param {ThirdPartyWebinarCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: ThirdPartyWebinarCreate, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThirdPartyWebinar> {
            const localVarAxiosArgs = ThirdPartyWebinarApiAxiosParamCreator(configuration).create(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner
         * @summary Edit third party webinar.
         * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
         * @param {ThirdPartyWebinarEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: ThirdPartyWebinarEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThirdPartyWebinar> {
            const localVarAxiosArgs = ThirdPartyWebinarApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner`
         * @summary Get third party webinar.
         * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThirdPartyWebinar> {
            const localVarAxiosArgs = ThirdPartyWebinarApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ThirdPartyWebinarApi - factory interface
 * @export
 */
export const ThirdPartyWebinarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.content_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Create new third party webinar.
         * @param {ThirdPartyWebinarCreate} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(body?: ThirdPartyWebinarCreate, options?: any) {
            return ThirdPartyWebinarApiFp(configuration).create(body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner
         * @summary Edit third party webinar.
         * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
         * @param {ThirdPartyWebinarEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: ThirdPartyWebinarEdit, options?: any) {
            return ThirdPartyWebinarApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner`
         * @summary Get third party webinar.
         * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return ThirdPartyWebinarApiFp(configuration).get(id, options)(axios, basePath);
        },
    };
};

/**
 * ThirdPartyWebinarApi - object-oriented interface
 * @export
 * @class ThirdPartyWebinarApi
 * @extends {BaseAPI}
 */
export class ThirdPartyWebinarApi extends BaseAPI {
    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.content_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">model</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Create new third party webinar.
     * @param {ThirdPartyWebinarCreate} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyWebinarApi
     */
    public create(body?: ThirdPartyWebinarCreate, options?: any) {
        return ThirdPartyWebinarApiFp(this.configuration).create(body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `webinar.owner` or `webinar.company.owner
     * @summary Edit third party webinar.
     * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
     * @param {ThirdPartyWebinarEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyWebinarApi
     */
    public edit(id: string, body?: ThirdPartyWebinarEdit, options?: any) {
        return ThirdPartyWebinarApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `webinar.owner` or `webinar.company.owner`
     * @summary Get third party webinar.
     * @param {string} id Id of &#x60;Webinar&#x60; entity, not &#x60;ThirdPartyWebinar&#x60;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThirdPartyWebinarApi
     */
    public get(id: string, options?: any) {
        return ThirdPartyWebinarApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

}
